export { default as ProductShopListSkeleton } from './ProductShopListSkeleton';
